import React, { useContext } from "react";
import { CertificationSessionInterface } from "module/certification/types";
import CertificationSessionContext from "module/certificationSession/context/CertificationSessionContext";
import CertificationSessionTableRowItem from "./CertificationSessionTableRowItem";

const CertificationSessionTableRowItemContainer: React.FC = () => {
  const { entity } = useContext(CertificationSessionContext);

  const certificationSession = entity as CertificationSessionInterface;
  const { name, level } = certificationSession;

  return <CertificationSessionTableRowItem {...{ name, level }} />;
};

export default React.memo(CertificationSessionTableRowItemContainer);
